import { hits } from 'instantsearch.js/es/widgets';
import productTileTemplate from '../templates/productTileTemplate';
import formatDoubleBraces from '../../../utils/formatDoubleBraces';
import duplicateElement from '../utils/duplicateElement';
import { removeEmptyLabelHref } from '../utils/removeEmptyLabelHref';
import { removeEmptyFicheLink } from '../utils/removeEmptyFicheLink';
import getAttributeValue from '../../../../utils/getAttributeValue';
import { displaySortByWidget } from './sortBy';

// hits are product tiles
export const initHits = () => {
	const templateCdnImageProductTile = document.getElementById(
		'template_cdnImage_productTile',
	).innerHTML;

	const templateEnergyRating = document.getElementById(
		'template_energyRating',
	).innerHTML;

	const templatePricePanel = document.getElementById(
		'template_pricePanel',
	).innerHTML;

	const templateProcuctPriceTable = document.getElementById(
		'template_productPriceTable',
	).innerHTML;

	const templateStockInfo =
		document.getElementById('template_stockInfo').innerHTML;

	const templateAddToCartPanel = document.getElementById(
		'template_addToCartPanel',
	).innerHTML;

	const stockMessage = getAttributeValue(
		'.algolia-search-list-page__products',
		'data-stock-message',
	);

	return hits({
		// TODO: Determine if using 'id' would be better to target HTML elements rather than class names for the algolia widgets
		container: '.algolia-search-list-page__products',
		templates: {
			item(hit) {
				hit.pageLanguage = window.dataLayer[0].navigation?.pageLanguage;

				hit.cdnImageHtml = formatDoubleBraces(templateCdnImageProductTile, {
					imageUrl: hit.productId,
					title: hit.productTitle,
				});

				if (hit.productEnergyData?.energyRating) {
					hit.energyRatingHtml = formatDoubleBraces(templateEnergyRating, {
						energyRating: hit.productEnergyData?.energyRating?.charAt(0),
						energyRatingPostfix: hit.productEnergyData?.energyRating?.slice(1),
						energyRatingNormalisedValue:
							hit.productEnergyData?.energyRatingNormalisedValue,
						energyLabelUrl: (hit.energyLabelUrl = !hit.productEnergyData
							?.energyLabelUrl
							? '*emptyLabelUrl*'
							: hit.productEnergyData.energyLabelUrl),
						energyFicheUrl: (hit.energyFicheUrl = !hit.productEnergyData
							?.energyFicheUrl
							? '*emptyFicheUrl*'
							: hit.productEnergyData.energyFicheUrl),
					});

					hit.energyRatingHtml = removeEmptyFicheLink(
						removeEmptyLabelHref(hit.energyRatingHtml),
					);
				} else {
					hit.energyRatingHtml = ``;
				}

				hit.pricePanelHtml = formatDoubleBraces(templatePricePanel, {
					productPriceFormattedValue: hit.price?.currencySymbol ?? '€',
					dummyAlternatePrice: Intl.NumberFormat('nl', {
						style: 'currency',
						currency: hit.price?.currencyISO ?? 'EUR',
					}).format(hit.price?.priceValue ?? ''),
				});

				if (hit.price?.volumePricesCount > 1) {
					hit.productPriceTableHtml = duplicateElement(
						templateProcuctPriceTable,
						'.product-price-table__row',
						hit.price.volumePricesCount - 1,
					);
				} else {
					hit.productPriceTableHtml = ``;
				}

				if (hit.stock?.inStock) {
					hit.stockInfoHtml = formatDoubleBraces(templateStockInfo, {
						modifierClass: '--in-stock',
						stockMessage,
						productLegacySKU: hit.legacyProductId,
					});
				} else {
					hit.stockInfoHtml = ``;
				}

				hit.productAddToCartHtml = templateAddToCartPanel;

				return productTileTemplate(hit);
			},
			empty: () => '',
		},
		transformItems(items, { results }) {
			if (results.nbHits > 0) displaySortByWidget();
			return items;
		},
	});
};
